<template>
  <v-card style="height: 459px" class="card-container">
    <v-card-title class="pt-5 pl-6">
      <v-container class="pa-0 justify-space-between" fluid fill-height>
        <div>
          <span class="table-card-title d-flex">Horário de compra</span>
          <p class="mb-0 subtitle">Esse gráfico agrupa os cupons realizados dentro da campanha, por horário.</p>
        </div>
        <chart-type-toggle-button :type.sync="chartType" />
      </v-container>
    </v-card-title>
    <v-card-text>
      <mf-loading :boolean-loader="loading" loader-type="chart">
        <apex-chart
          v-if="ticketsByHourChartData[0].data.reduce((total, valor) => total + valor, 0) > 0"
          class="pr-5 pl-5"
          type="line"
          height="350"
          :options="chartOptions"
          :series="ticketsByHourChartData"
        />
        <empty-chart v-if="ticketsByHourChartData[0].data.reduce((total, valor) => total + valor, 0) === 0" paddingTop="130px" />
      </mf-loading>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { colors } from '@/config/colors.js'
import ChartTypeToggleButton from '@/components/ChartTypeToggleButton.vue'
import EmptyChart from '@/modules/mobile/desempenho/views/components/EmptyChart'

export default {
  name: 'TimeBiggestPurchaseChart',
  components: {
    ApexChart: VueApexCharts,
    ChartTypeToggleButton,
    EmptyChart,
  },
  props: {
    metricsPeriod: {
      type: String,
      default: () => '',
    },
    dataChart: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    chosenCustomerType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    chartType: 'line',
    chartIndex: 0,
  }),
  computed: {
    chartRange() {
      return [
        '00:00',
        '01:00',
        '02:00',
        '03:00',
        '04:00',
        '05:00',
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00',
      ]
    },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: this.chartType,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          background: '#fff',
        },
        fill: {
          opacity: 1,
          type: 'solid',
        },
        grid: {
          padding: {
            top: 10,
            right: 20,
            bottom: 10,
            left: 20,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: this.metricsPeriod === 'MONTHLY' ? '50px' : '20px',
            borderRadius: 3,
            dataLabels: {
              position: 'top',
            },
          },
        },
        colors: [colors[0]],
        legend: {
          horizontalAlign: 'left',
          markers: {
            width: 7,
            height: 7,
          },
          offsetX: 5,
          offsetY: -10,
        },
        markers: {
          size: 2,
          colors: colors[0],
          strokeColors: colors[0],
          strokeWidth: 2,
          strokeOpacity: 1,
          strokeDashArray: 0,
          fillOpacity: 1,
          shape: 'circle',
          radius: 2,
          showNullDataPoints: true,
          hover: {
            sizeOffset: 2,
          },
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            const registers = series[0][dataPointIndex]

            return `
              <v-card class="d-flex flex-row justify-start pa-1">
                <span><strong>${registers.toLocaleString()} </strong>${registers > 1 || registers === 0 ? 'cupons' : 'cupom'}</span>
              </v-card>
            `
          },
        },
        dataLabels: {
          enabled: true,
          offsetY: this.chartType === 'bar' ? -20 : -10,
          style: {
            fontSize: '12px',
            colors: ['#F9FAFB'],
            fontWeight: 'normal',
          },
          background: {
            enabled: true,
            foreColor: '#969EA7',
            padding: 4,
            borderRadius: 2,
          },
          formatter(val) {
            const formattedValue = val === null ? '' : val >= 1000 ? `${(val / 1000).toFixed(1)}k` : val
            return formattedValue
          },
        },
        stroke: {
          curve: 'smooth',
          colors: [colors[0]],
          width: 3,
        },
        xaxis: {
          categories: this.chartRange,
          category: 'numeric',
          labels: {
            style: {
              colors: '#969EA7',
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              if (!val) return
              return val.toLocaleString()
            },
          },
        },
        states: {
          hover: {
            filter: {
              type: 'lighten',
              value: 0.1,
            },
          },
        },
      }
    },
    ticketsByHourChartData() {
      if (!this.dataChart.length) return [{ data: [] }]
      return [{ data: this.dataChart.map((hour) => hour[this.chosenCustomerType].tickets) }]
    },
  },
  watch: {
    metricsPeriod() {
      this.chartIndex = 0
    },
  },
}
</script>

<style lang="scss" scoped>
.card-container {
  min-height: 400px;
}
.local-subtitle {
  width: 80%;
}
</style>
